$(document).ready(function(){
    let swiper = new Swiper('.swiper:not(.custom)', {
        loop: true,
        speed: 400,
        autoHeight: false,
        watchOverflow: true,
        spaceBetween: 15,
        slidesPerView: 'auto',

        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        on: {
            init() {
                this.el.addEventListener('mouseenter', () => {
                    this.autoplay.stop();
                });

                this.el.addEventListener('mouseleave', () => {
                    this.autoplay.start();
                });
            }
        },
    });

    // слайдер в header
    {
      if($('.header-slider-item').length > 1) {
        new Swiper('.header-slider .swiper', {
          loop: true,
          speed: 400,
          spaceBetween: 15,
          allowTouchMove: false,
    
          autoplay: {
            delay: 5000,
          },
        });
      };

      $('.header-slider-close').on('click', function() {
        $('.header-slider').remove();
      })
    }


    $('.flexslider-review').flexslider({
        directionNav: true,
        controlNav :true,
        animationLoop: true,
        slideshow: false,
        customDirection: ".reviews .nav-direction a",
        itemMargin: 32,
        counts: [2, 2, 1],

        minItems: 1,
        maxItems: 2
    });

    $('.plus-minus-toggle').click(function(){
        let menu    = $(this).closest('ul');
        let li      = $(this).closest('li');
        let childID = li.attr('data-id-item');
        menu.find('[data-id-child-item="'+childID+'"]').toggleClass('child_item_hidden');
        $(this).toggleClass('collapsed');
    });

    var leftBlock = document.querySelector('.catalog_page .left_block');
    if (leftBlock) {
        new SimpleBar(leftBlock);
    }

    var multiItemSlider = (function () {
        return function (selector, config) {
            var
                _mainElement = document.querySelector(selector),
                _sliderWrapper = _mainElement.querySelector('.slider__wrapper'),
                _sliderItems = _mainElement.querySelectorAll('.slider__item'),
                _sliderControls = _mainElement.querySelectorAll('.slider__control'),
                _sliderControlLeft = _mainElement.querySelector('.slider__control_left'),
                _sliderControlRight = _mainElement.querySelector('.slider__control_right'),
                _wrapperWidth = parseFloat(getComputedStyle(_sliderWrapper).width),
                _itemWidth = parseFloat(getComputedStyle(_sliderItems[0]).width),
                _positionLeftItem = 0,
                _transform = 0,
                _step = _itemWidth / _wrapperWidth * 100,
                _items = [];
            // наполнение массива _items
            _sliderItems.forEach(function (item, index) {
                _items.push({ item: item, position: index, transform: 0 });
            });

            var position = {
                getMin: 0,
                getMax: _items.length - 1,
            }

            var _transformItem = function (direction) {
                if (direction === 'right') {
                    if ((_positionLeftItem + _wrapperWidth / _itemWidth - 1) >= position.getMax) {
                        return;
                    }
                    if (!_sliderControlLeft.classList.contains('slider__control_show')) {
                        _sliderControlLeft.classList.add('slider__control_show');
                    }
                    if (_sliderControlRight.classList.contains('slider__control_show') && (_positionLeftItem + _wrapperWidth / _itemWidth) >= position.getMax) {
                        _sliderControlRight.classList.remove('slider__control_show');
                    }
                    _positionLeftItem++;
                    _transform -= _step;
                }
                if (direction === 'left') {
                    if (_positionLeftItem <= position.getMin) {
                        return;
                    }
                    if (!_sliderControlRight.classList.contains('slider__control_show')) {
                        _sliderControlRight.classList.add('slider__control_show');
                    }
                    if (_sliderControlLeft.classList.contains('slider__control_show') && _positionLeftItem - 1 <= position.getMin) {
                        _sliderControlLeft.classList.remove('slider__control_show');
                    }
                    _positionLeftItem--;
                    _transform += _step;
                }
                _sliderWrapper.style.transform = 'translateX(' + _transform + '%)';
            }

            // обработчик события click для кнопок "назад" и "вперед"
            var _controlClick = function (e) {
                if (e.target.classList.contains('slider__control')) {
                    e.preventDefault();
                    var direction = e.target.classList.contains('slider__control_right') ? 'right' : 'left';
                    _transformItem(direction);
                }
            };

            var _setUpListeners = function () {
                // добавление к кнопкам "назад" и "вперед" обрботчика _controlClick для событя click
                _sliderControls.forEach(function (item) {
                    item.addEventListener('click', _controlClick);
                });
            }

            // инициализация
            _setUpListeners();

            return {
                right: function () { // метод right
                    _transformItem('right');
                },
                left: function () { // метод left
                    _transformItem('left');
                }
            }

        }
    }());

    if ($('.options').length) {
        var slider = multiItemSlider('.options');

        var sliderItem = $('.js-slider_item'),
            sliderSl = $('.js-slider'),
            sliderControlRight = $('.slider__control_right');

        if(sliderItem.length > 5){
            sliderControlRight.addClass("slider__control_show");
        }else{
            SliderStyle();
            if(sliderItem.length === 4){
                $(window).resize(function() {
                    var windowWidth = $(window).width();
                    if((windowWidth <= '1040' && windowWidth >= '992') || (windowWidth <= '800' && windowWidth >= '601') || windowWidth <= '400'){
                        SliderStyleAfter();
                    }else{
                        SliderStyleBefore();
                    }
                });
            }
            if(sliderItem.length === 5){
                $(window).resize(function() {
                    var windowWidth = $(window).width();
                    if ((windowWidth <= '1240' && windowWidth >= '601') ||  windowWidth <= '485'){
                        SliderStyleAfter();
                    }else{
                        SliderStyleBefore();
                    }
                });
            }
        }
    }
    function SliderStyle() {
        sliderSl.css({'margin' : '0'});
        sliderSl.css({'max-width' : '100%'});
        $('.js-slider_item:first-child').css({'padding-left' : '2px'});
    }

    function SliderStyleBefore() {
        SliderStyle();
        sliderControlRight.removeClass("slider__control_show");
    }

    function SliderStyleAfter() {
        sliderControlRight.addClass("slider__control_show");
        sliderSl.css({'margin' : '0 auto'});
        sliderSl.css({'max-width' : '82%'});
    }

    $('[name="licenses_order"]').prop('checked', true);
});

$(document).on('submit', '.reviews-form', function() {
    dataLayer.push({'event': 'order_review'});
});

$(document).on('submit', '.subscribe-form form, .footer-subscription form', function() {
    dataLayer.push({'event': 'order_mailing'});
});

$(document).on('click', '.to-cart', function() {
    dataLayer.push({'event': 'micro_add_cart'});
});

$(document).on('click', '.wish_item', function() {
    dataLayer.push({'event': 'micro_favorites'});
});

// $('.js-start-video').click(function () {
//     $('.preview-video').css('opacity', 1);
//     $('.product-detail__video video')[0].play();
//     $('.product-detail__video video')[0].setAttribute('controls', 'controls');

//     $(this).hide();
// });

$('.js-goto-product-video').on('click', function () {
    $('.js-video-thumb').click();
});

$(document).ready(function() {
  $('.custom__dropdown').each(function () {
    const customDropdown = $(this);
    const customDropdownList = customDropdown.find('.custom__dropdown-list');

    customDropdown.click(function() {
      customDropdown.attr('tabindex', 1).focus();
      customDropdown.toggleClass('active');
      customDropdownList.slideToggle(300);
    });
    $(window).click(function(e) {
      if(!e.target.closest('.custom__dropdown')) {
        customDropdown.removeClass('active');
        customDropdownList.slideUp(300);
      }
    })
  })
});